// defs
import { IAlert } from "@defs/Alert";
import { Stage } from "@helpers/index";

export type IPageAlertState = {
    alertMessage?: IAlert | undefined;
    bannerMessage?: IAlert | undefined;
    snackbarMessage?: IAlert | undefined;
};

export type IPageTitleState = {
    title?: string;
    subTitle?: string;
    icon?: string;
    endToEnd?: boolean;
};

export interface IAppState {
    isLoading: boolean;
    pageAlert: IPageAlertState;
    pageTitle: IPageTitleState;
    isSideMenuOpen: boolean;
    stage: Stage | null;
}

export const initialPageAlertState: IPageAlertState = {
    alertMessage: undefined,
    bannerMessage: undefined,
    snackbarMessage: undefined,
};

export const initialPageTitleState: IPageTitleState = {
    title: "",
    subTitle: "",
    icon: "",
    endToEnd: false,
};

export const initialAppState: IAppState = {
    isLoading: false,
    pageAlert: initialPageAlertState,
    pageTitle: initialPageTitleState,
    isSideMenuOpen: false,
    stage: null,
};
